import { useEffect } from "react";
import { CalendarClock } from "lucide-react";
import { MaskText, FadeUp } from "./MaskText";
import { useLocale } from "@/i18n/LocaleContext";
import { CALENDLY } from "@/i18n/translations";

export const Consultation = () => {
  const { t } = useLocale();
  const c = t.consult;

  useEffect(() => {
    const id = "calendly-widget-script";
    if (document.getElementById(id)) return;
    const s = document.createElement("script");
    s.id = id;
    s.src = "https://assets.calendly.com/assets/external/widget.js";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  const url = `${CALENDLY.url}?hide_gdpr_banner=1&background_color=050505&text_color=f4f4f0&primary_color=00f0ff`;

  return (
    <section id="book" className="relative border-t border-white/10 py-24 md:py-32" data-testid="consultation-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <FadeUp>
              <span className="inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-nowi-venture">
                <CalendarClock className="w-4 h-4" strokeWidth={1.5} />
                {c.kicker}
              </span>
            </FadeUp>
            <MaskText
              lines={c.heading}
              className="mt-5 font-playfair text-4xl md:text-6xl leading-[0.95] tracking-[-0.02em]"
            />
          </div>
          <FadeUp delay={0.1}>
            <p className="max-w-sm text-nowi-muted text-sm md:text-base">{c.subtitle}</p>
          </FadeUp>
        </div>

        <FadeUp delay={0.15}>
          <div
            className="calendly-inline-widget border border-white/10 bg-nowi-surface"
            data-url={url}
            data-testid="calendly-widget"
            style={{ minWidth: "320px", height: "720px" }}
          />
        </FadeUp>
      </div>
    </section>
  );
};
